import { useState } from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { 
  Swiper, 
  SwiperSlide,
} from 'swiper/react';
 import { 
  Pagination,
  Autoplay,
} from 'swiper/modules';

import styles from './Dev.module.css';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const loveAppSliderData = [
  'Personalised meal planning',
  'Grocery shopping assistant',
  'Reach your goal weight',
];

const LoveSliderTrackingContent = () => (
  <div className={cn(styles.loveSliderContent, styles.loveTracking)}>
    <div className={styles.loveSliderInfo}>
      <div className={styles.loveTitle}>
        Tracking Your Achievements
      </div>
      <div className={styles.loveSubTitle}>
        You’ll see how far you’ve come with just one click.     
      </div>
      <Link 
        to="/get-meal-plan"
        className={styles.greenButton}
      >
        Try for free
      </Link>
    </div>
  </div>
);

const LoveSliderPersonalizedContent = () => (
  <div className={cn(styles.loveSliderContent, styles.lovePersonalized)}>
    <div className={styles.loveSliderInfo}>
      <div className={styles.loveTitle}>
        Personalised meal planing
      </div>
      <div className={styles.loveSubTitle}>
        Our recipes are created by leading nutritionists, and perfectly balanced for each individual by AI.
      </div>
      <Link 
        to="/get-meal-plan"
        className={styles.greenButton}
      >
        Try for free
      </Link>
    </div>
  </div>
);

const LoveSliderHealthyContent = () => (
  <div className={cn(styles.loveSliderContent, styles.loveHealthy)}>
    <div className={styles.loveSliderInfo}>
      <div className={styles.loveTitle}>
        Healthy eating<br />
        Shopping list
      </div>
      <div className={styles.loveSubTitle}>
        We’ll even put your ingredients in your favourite online supermarket basket.
      </div>
      <Link 
        to="/get-meal-plan"
        className={styles.greenButton}
      >
        Try for free
      </Link>
    </div>
  </div>
);

const LoveSection = () => {
  const [swiper, setSwiper] = useState(null);
  const [loveSliderIndex, setLoveSliderIndex] = useState(0);

  const changeSliderPage = (index) => {
    if (swiper) {
      swiper.slideToLoop(index);
    }
  };

  return (
    <section className={cn(styles.section, styles.loveAppSection)}>
      <div className={styles.sectionTitle}>
        Why You’ll Love Our App
      </div>
      <div className={styles.sliderButtons}>
        {loveAppSliderData.map((label, index) => (
          <div 
            key={index}
            onClick={() => changeSliderPage(index)} 
            className={cn(
              styles.sliderButton, 
              { [styles.activeSliderButton]: index === loveSliderIndex }
            )}
          >
            {label}
          </div>
        ))}
      </div>
      <div className={styles.loveSliderWrapper}>
        <Swiper 
          modules={[Pagination, Autoplay]}
          onSwiper={setSwiper}
          className={styles.slider} 
          spaceBetween="24" 
          slidesPerView="1" 
          navigation
          pagination={{ 
            clickable: true,
          }}
          autoplay={{ 
            delay: 3000,
            disableOnInteraction: false,
          }}  
          // centeredSlides
          // loop   
          onSlideChange={swiper => setLoveSliderIndex(swiper.realIndex)}
          onSlideEnd={() => setLoveSliderIndex(0)}
        >
          <SwiperSlide className={styles.loveSliderSlide}>
            <LoveSliderPersonalizedContent />
          </SwiperSlide>
          <SwiperSlide className={styles.loveSliderSlide}>
            <LoveSliderHealthyContent />
          </SwiperSlide>
          <SwiperSlide className={styles.loveSliderSlide}>
            <LoveSliderTrackingContent />
          </SwiperSlide>
        </Swiper>
      </div>
    </section>
  );
};

export default LoveSection;
